import { useContext } from 'react';

import { ThemeContext, type ThemeContextType } from '@features/Theme/provider';

export const useTheme = (): ThemeContextType => useContext(ThemeContext);
